<template>
	<div class="loading">
		<div class="load-wrapp">
            <div class="load">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
            </div>
        </div>
        <div class="clear"></div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){

			},
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.loading {
		text-align: center;
		margin: auto;
		// background-color: #f0f0f0;
	}
	.load-wrapp {
	    height: 50px;
	    border-radius: 5px;
	    padding: 10px 0;
	    text-align: center;
	}
	.line {
	    display: inline-block;
	    width: 15px;
	    height: 15px;
	    margin: 0 10px;
	    border-radius: 15px;
	    background-color: $theme-color;
	}
	.clear {
		clear:both;
	}
	.load .line:nth-last-child(1) {animation: loadingC .6s .1s cubic-bezier(0, 0, 0.2, 1) infinite;}
	.load .line:nth-last-child(2) {animation: loadingC .6s .2s cubic-bezier(0, 0, 0.2, 1) infinite;}
	.load .line:nth-last-child(3) {animation: loadingC .6s .3s cubic-bezier(0, 0, 0.2, 1) infinite;}
	@keyframes loadingC {
	    0% {transform: translate(0,0);}
	    50% {transform: translate(0,15px);}
	    100% {transform: translate(0,0);}
	}
</style>